import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'homePage', en);

const HomeNotificationConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Notifications',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.HOME,
  permission: PERMISSION.READ,
  routes: [
    {
      path: '/home/notifications',
      component: React.lazy(() => import('./HomeNotification')),
    },
  ],
};

export default HomeNotificationConfig;
